import React from 'react'
import { Form, FormGroup, Input, InputGroup, Row, Col, Label, FormFeedback } from 'reactstrap'

export const FormUnit = (props) => {

    const { unit, abbreviation, handleInputChange, methodAction } = props;

    return (
        <Form role="form" onSubmit={methodAction}>
            <div className='form-section'>

                <div className="form-title-container">
                    <h4 className="form-title-custom">
                        Configuración deunidades
                    </h4>
                </div>

                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-custom">
                                Nombre
                                <span className="label-required"> *</span>
                            </Label>

                            <Input
                                type="text"
                                autoComplete="off"
                                name="unit"
                                value={unit}
                                onChange={handleInputChange}
                                placeholder="Ej. x10^9/L"
                                className="input-custom"
                            />

                            <FormFeedback>
                                Debes llenar este campo
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                    <Col md="6">
                        <FormGroup>
                            <Label className="label-custom">
                                Abreviatura <span className="label-required"> *</span>
                            </Label>

                            <Input
                                type="text"
                                autoComplete="off"
                                name="abbreviation"
                                value={abbreviation}
                                onChange={handleInputChange}
                                placeholder="Ej. x10^9/L"
                                className="input-custom"
                            />
                        </FormGroup>
                        
                        <FormFeedback>
                            Debes llenar este campo
                        </FormFeedback>

                    </Col>
                    
                </Row>
                    
            </div>
                
           
        </Form>
    )
}
